import { useEffect } from 'react';
import { Outlet } from 'react-router';

// Store
import { NotificationProvider } from '@store/notifications';

// UI
import Notifications from '@components/notifications-list';

function AuthPageLayout() {
  useEffect(() => {
    document.body.classList.add('adjust-for-onboarding-pages');

    return () => {
      document.body.classList.remove('adjust-for-onboarding-pages');
    };
  }, []);

  return (
    <NotificationProvider>
      <Outlet />
      <Notifications />
    </NotificationProvider>
  );
}

export default AuthPageLayout;
